import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { NoAccessComponent } from './shared/components/no-access/no-access.component';
import { InspectorComponent } from './pages/inspector/inspector.component';
import { SuppliersComponent } from './pages/suppliers/suppliers.component';
import { UsersComponent } from './pages/users/users.component';

export const appRoutes: Routes = [
    { path: 'no-access', component: NoAccessComponent },
    {
        path: 'inspectors',
        component: InspectorComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'suppliers',
        component: SuppliersComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'users',
        component: UsersComponent,
        canActivate: [MsalGuard]
    },
    { path: '**', redirectTo: '/inspectors' }
];
